import { Injectable } from '@angular/core';
import { VariableTypeEnum } from '../../../../shared/ontology/variable-type.enum';
import { VariableDetails } from '../../../../shared/ontology/model/variable-details';

export interface MapItem {
    id: string;
    name: string;
    variable?: VariableDetails
    property?: string;
    scale?: string;
    method?: string;
}

@Injectable({ providedIn: 'root' })
export class ImportStudyContext {
    datasetId: number;
    isEnvironmentsImportBoolean: boolean;
    isStudySettingsImportBoolean: boolean;
    isDesignDetailsImportBoolean: boolean;
    unmappedItems: MapItem[];
    variableTypeIds: VariableTypeEnum[] = [];
    excludedVariableIds: number[];
    importedData: any[];
}
